import type { LocaleCode } from '@/i18n/locales'
import type { CategoryLocaleEntry, CategoryPageLocaleCopy } from '../types'
import { categoryContentEn, categoryPageCopyEn } from './en'
import { categoryContentEs, categoryPageCopyEs } from './es'

export function getCategoryPageCopy(locale: LocaleCode): CategoryPageLocaleCopy {
  return locale === 'es' ? categoryPageCopyEs : categoryPageCopyEn
}

export function getCategoryContent(locale: LocaleCode, category: string): CategoryLocaleEntry | undefined {
  if (locale === 'es') {
    return categoryContentEs[category] ?? categoryContentEn[category]
  }

  return categoryContentEn[category]
}
